import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import List from '../AnimationList';
import { tabsClass } from './styles';
var CollapseList = List(['collapse'], 'fast');

var Panel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Panel, _PureComponent);

  var _super = _createSuper2(Panel);

  function Panel(props) {
    var _this;

    _classCallCheck(this, Panel);

    _this = _super.call(this, props);
    _this.isPristine = void 0;
    _this.isPristine = true;
    return _this;
  }

  _createClass(Panel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          background = _this$props.background,
          color = _this$props.color,
          isActive = _this$props.isActive,
          collapsible = _this$props.collapsible,
          collapsed = _this$props.collapsed,
          lazy = _this$props.lazy;
      if (!isActive && this.isPristine && lazy) return null;
      this.isPristine = false;
      var style = Object.assign({
        background: background || '#fff',
        color: color
      }, this.props.style);
      var className = classnames(tabsClass('panel', isActive && 'show'), this.props.className);
      var result =
      /*#__PURE__*/
      React.createElement("div", {
        style: style,
        className: className
      }, children);
      if (!collapsible) return result;
      return (
        /*#__PURE__*/
        React.createElement(CollapseList, {
          show: !collapsed
        }, result)
      );
    }
  }]);

  return Panel;
}(PureComponent);

Panel.isTabPanel = void 0;
Panel.isTabPanel = true;
export default Panel;